export const CASE_MODULES = {
    fax_intake: { label: "Fax intake", short: "Fax", icon: "mdi-fax" },
    benefits_verification: { label: "Benefit verification", short: "BV", icon: "mdi-shield-check-outline" },
    necessity_check: { label: "Policy check", short: "Policy", icon: "mdi-file-search-outline" },
    clinical_review: { label: "Medical necessity", short: "MN", icon: "mdi-stethoscope" },
    prior_auth: { label: "Prior auth", short: "PA", icon: "mdi-file-document-check-outline" },
};
export const MODULE_ORDER = Object.keys(CASE_MODULES);
const RETIRED_MODULES = { order_qualification: "benefits_verification" };
/** A module's current key: a retired module's step reads as the module that replaced it. */
export function currentModuleKey(key) {
    return RETIRED_MODULES[key] ?? key;
}
export function caseModule(key) {
    return CASE_MODULES[currentModuleKey(key)] ?? { label: key, short: key, icon: "mdi-circle-small" };
}
const POLICY_CHECK = "necessity_check";
const MEDICAL_NECESSITY = "clinical_review";
const URGENCY = [
    "NEEDS_ATTENTION",
    "READY",
    "IN_PROGRESS",
    "WAITING",
    "NOT_STARTED",
    "DONE",
    "NOT_NEEDED",
    "CANCELLED",
];
function urgency(state) {
    const rank = URGENCY.indexOf(state);
    return rank === -1 ? URGENCY.length : rank;
}
/** With MN on, the policy check shows as Medical necessity, carrying the more urgent of the two; with MN off it stays. */
export function withMedicalNecessity(steps, medicalNecessity = true) {
    const checks = steps.filter((step) => step.moduleKey === POLICY_CHECK);
    if (!checks.length || !medicalNecessity)
        return steps;
    const asReview = (step) => ({ ...step, moduleKey: MEDICAL_NECESSITY });
    if (!steps.some((step) => step.moduleKey === MEDICAL_NECESSITY)) {
        return steps.map((step) => (checks.includes(step) ? asReview(step) : step));
    }
    const urgent = checks.reduce((most, step) => (urgency(step.state) < urgency(most.state) ? step : most));
    return steps
        .filter((step) => !checks.includes(step))
        .map((step) => step.moduleKey === MEDICAL_NECESSITY && urgency(urgent.state) < urgency(step.state) ? asReview(urgent) : step);
}
